import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import IndexReducer from "./index-reducer";
import IndexSaga from "./index-sagas";

import { routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { Switch, Redirect, Route } from 'react-router-dom';

import i18next from './i18n/config';
import { I18nextProvider } from "react-i18next";

import * as serviceWorker from './serviceWorker';

import 'bootstrap/dist/js/bootstrap.min.js'
import 'semantic-ui-css/semantic.min.css';
import './styles/app-styles.scss';

import AccountLogin from './container/account-login';
import AccountLogout from './container/account-logout';
import AccountValidate from './container/account-validate';
import AccountRegister from './container/account-register';
import MyView from './container/my-view';
import VolunteerApplicationApproval from './container/volunteer-application-approval';
import VolunteerApplications from './container/volunteer-applications';

export const history = createBrowserHistory({
  basename: '/dashboard'
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  IndexReducer(history),
  composeEnhancers(
    applyMiddleware(
      sagaMiddleware,
      routerMiddleware(history)
    )
  )
);
sagaMiddleware.run(IndexSaga);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18next}>
          <Switch>
            <Route path="/register" component={AccountRegister}/>
            <Route path="/validate/:validateId" component={AccountValidate}/>
            <Route path="/login" component={AccountLogin}/>
            <Route path="/logout" component={AccountLogout}/>
            <Route path="/me" component={MyView}/>
            <Route path="/volunteer-applications" component={VolunteerApplications} exact/>
            <Route path="/volunteer-applications/:applicationId" component={VolunteerApplicationApproval} exact/>
            <Redirect to="/login"/>
          </Switch>
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
